import type { VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'vue';

import { cva } from 'class-variance-authority';

export { default as GlassButton } from './GlassButton.vue';

export const glassButtonVariants = cva(
	'flex cursor-pointer items-center justify-center overflow-hidden border border-white/10 bg-[rgba(102,102,102,0.3)] backdrop-blur-[6px]',
	{
		variants: {
			variant: {
				default:
					'transition-colors hover:border-white/25 hover:bg-[rgba(102,102,102,0.5)]',
				action:
					'transition-all hover:scale-105 hover:bg-white/20 active:scale-95 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:scale-100 disabled:hover:bg-[rgba(102,102,102,0.3)]'
			},
			shape: {
				circle: 'rounded-full',
				square: 'rounded-[2px]'
			},
			size: {
				auto: '',
				sm: 'size-10',
				md: 'size-12',
				lg: 'size-14'
			}
		},
		defaultVariants: {
			variant: 'default',
			shape: 'circle',
			size: 'auto'
		}
	}
);

export type GlassButtonVariants = VariantProps<typeof glassButtonVariants>;

export interface GlassButtonProps {
	class?: HTMLAttributes['class'];
	variant?: GlassButtonVariants['variant'];
	shape?: GlassButtonVariants['shape'];
	size?: GlassButtonVariants['size'];
}
